// extracted by mini-css-extract-plugin
module.exports = {"popular-searches":"popular-searches_popular-searches__VyrHM","wrap":"popular-searches_wrap__4EH7D"};